<template>
  <div :class="containerClass">
    <div
      v-for="n in count"
      :key="`loading-more-${variant}-${n}`"
      :class="itemClass"
    >
      <template v-if="variant === 'product'">
        <div class="item__line">
          <Skeleton
            shape="rectangle"
            class="skeleton__line--large"
          />
        </div>
        <ul class="item__list">
          <li class="item__line">
            <Skeleton
              shape="rectangle"
              class="skeleton__line--medium"
            />
          </li>
          <li class="item__line">
            <Skeleton
              shape="rectangle"
              class="skeleton__line--medium"
            />
          </li>
          <li class="item__line">
            <Skeleton
              shape="rectangle"
              class="skeleton__line--small"
            />
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="item__line">
          <Skeleton
            shape="rectangle"
            class="skeleton__design--large"
          />
        </div>
        <div class="item__line">
          <Skeleton
            shape="rectangle"
            class="skeleton__design--small"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {Skeleton} from '@progress/kendo-vue-indicators'

const props = withDefaults(defineProps<{
  count?: number
  variant?: 'product' | 'design'
}>(), {
  count: 20,
  variant: 'product'
})

const containerClass = computed(() => ({
  'section__items': true,
  'section__items--loading-more': props.variant === 'product',
  'section__items--loading-more-designs': props.variant === 'design'
}))

const itemClass = computed(() => ({
  'item': true,
  'item--skeleton': true,
  'item--design-skeleton': props.variant === 'design'
}))
</script>

<style lang="scss" scoped>
.section__items {
  display: flex;
  flex-direction: column;

  &--loading-more {
    padding-top: 0.5rem;

    .item--skeleton {
      pointer-events: none;
    }
  }

  &--loading-more-designs {
    padding-top: 0.5rem;

    .item--design-skeleton {
      padding: 0.5rem 1rem;
      pointer-events: none;
    }
  }
}

.item {
  padding: .5rem 1rem;
  border-bottom: 0.0625rem solid $color--input__border;
  cursor: pointer;
  font-weight: $base-text-font-weight-light;

  &:last-child {
    border-bottom: none;
  }

  &__line {
    font-size: 0.875rem;
  }

  &__list {
    margin: .25rem 0 0;
    padding-left: 1.5rem;
    list-style-type: disc;

    .item__line {
      font-size: 0.75rem;
      margin: 0;
      padding-left: 0.25rem;

      &::marker {
        font-size: 0.625rem;
      }
    }
  }
}

.skeleton__line--large {
  width: 85%;
  height: 0.875rem;
  margin-bottom: 0.5rem;
}

.skeleton__line--medium {
  width: 75%;
  height: 0.75rem;
  margin-bottom: 0.35rem;
}

.skeleton__line--small {
  width: 60%;
  height: 0.75rem;
}

.skeleton__design--large {
  width: 50%;
  height: 1rem;
  margin-bottom: 0.5rem;
}

.skeleton__design--small {
  width: 30%;
  height: 0.875rem;
}
</style>
